<template>
  <el-dialog
    :title="lotteryInfo.scanCodeGiftId ? '编辑线下领礼' : '新增线下领礼'"
    :visible.sync="visible"
    width="700px"
    :close-on-press-escape="false"
    @closed="handleClosed">
    <el-form
      ref="ruleForm"
      v-loading="loading"
      :model="lotteryInfo"
      :rules="rules"
      label-width="110px">
      <el-form-item
        label="活动名称:"
        prop="activityName">
        <el-input v-model="lotteryInfo.activityName"></el-input>
      </el-form-item>
      <el-form-item
        label="页面标题:"
        prop="title">
        <el-input v-model="lotteryInfo.title"></el-input>
      </el-form-item>
      <el-form-item
        label="图文内容:"
        prop="image">
        <desc-images
          v-model="lotteryInfo.image"
          :edit="true"></desc-images>
      </el-form-item>
    </el-form>
    <span slot="footer">
      <el-button
        :loading="loading"
        @click="toggleModal(false)">取 消</el-button>
      <el-button
        type="primary"
        :loading="loading"
        @click="handleSubmit">提 交</el-button>
    </span>
  </el-dialog>
</template>

<script>
import DescImages from '@/components/public/desc-images.vue'
// import moment from 'moment'
// import _ from 'lodash'
export default {
  name: 'LotteryRegisterModal',
  components: { DescImages },
  props: {
    callback: Function
  },
  data() {
    return {
      loading: false,
      visible: false,
      lotteryInfo: {
        vendorId: null,
        scanCodeGiftId: null,
        activityName: '',
        title: '',
        image: [],
        status: 1,
        beginTime: null,
        endTime: null
      }
    }
  },
  computed: {
    rules() {
      return {
        title: [
          { required: true, message: '请输入页面标题', trigger: 'change' }
        ],
        activityName: [
          { required: true, message: '请输入活动名称', trigger: 'blur' }
        ],
        image: [
          { required: true, type: 'array', message: '请上传图文内容', trigger: 'change' }
        ]
      }
    }
  },
  methods: {
    toggleModal(visible) {
      this.visible = visible
    },
    handleClosed() {
      this.lotteryInfo = {
        vendorId: null,
        scanCodeGiftId: null,
        activityName: '',
        title: '',
        image: [],
        status: 1,
        beginTime: null,
        endTime: null
      }
      this.$refs.ruleForm.clearValidate()
    },
    handleSubmit() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          this.loading = true
          const dispatch = this.lotteryInfo.scanCodeGiftId ? 'updatescancodegift' : 'addscancodegift'
          this.$store.dispatch(`coupon/${dispatch}`, {
            payload: {
              ...this.lotteryInfo,
              image: this.lotteryInfo.image.map(i => i.url).join(',')
            },
            success: () => {
              this.loading = false
              this.callback && this.callback()
              this.toggleModal(false)
            },
            fail: () => {
              this.loading = false
            }
          })
        }
      })
    },
    fetch({ vendorId, scanCodeGiftId }) {
      if (scanCodeGiftId) {
        this.loading = true
        this.$store.dispatch('coupon/getscancodegift', {
          payload: {
            vendorId, scanCodeGiftId
          },
          success: res => {
            this.loading = false
            const {
              // vendorId,
              // scanCodeGiftId,
              activityName,
              title,
              image,
              status,
              beginTime,
              endTime
            } = res.data
            this.lotteryInfo = {
              ...this.lotteryInfo,
              vendorId,
              scanCodeGiftId,
              activityName,
              title,
              image: image ? image.split(',').map(item => ({
                url: item,
                name: item,
                mediaType: /(\.mp4|\.webm|\.avi)$/g.test(item) ? 2 : 1
              })) : [],
              status,
              beginTime,
              endTime
            }
            this.toggleModal(true)
          },
          fail: () => {
            this.loading = false
          }
        })
      } else {
        this.toggleModal(true)
      }
    }
  }
}
</script>
